import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { Itinerary } from '../../../models/itinerary';
import { CommonModule } from '@angular/common';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from '../../../../shared/shared.module';
import { ButtonTriggerEvent } from '../../../../../common/components/button/button.component';
import { VisitorService } from '../../../../shared/services/visitor.service';
import { finalize } from 'rxjs/operators';
import { removeHtmlTags } from '../../../../../common/utils/string.extensions';

@Component({
  selector: 'ig-attraction-description-generator',
  standalone: true,
  imports: [
    MatMenuModule,
    CommonModule,
    MatCheckbox,
    FormsModule,
    MatTooltipModule,
    SharedModule,
  ],
  templateUrl: './attraction.description.generator.component.html',
  styleUrl: './attraction.description.generator.component.scss',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'ig-attraction-description-generator',
  },
})
export class AttractionDescriptionGeneratorComponent {
  @Input() itinerary: Itinerary;
  @Input() parentTrigger: MatMenuTrigger;
  @Input() triggerText = 'AI content generation';
  @Input() isJustAddedPlaces = false;
  @Output() generated: EventEmitter<any> = new EventEmitter();

  selectAll = false;
  selectedItems = [];

  constructor(private _visitorService: VisitorService) {}

  handleOpen(event, menuTrigger: MatMenuTrigger) {
    // console.log('this.isJustAddedPlaces', this.isJustAddedPlaces);
    // if (this.isJustAddedPlaces) {
    //   event.stopPropagation();
    //   menuTrigger.closeMenu();
    //   return;
    // }
  }

  isSelected(id: string, type: 'pre' | 'post' | 'desc') {
    const exist = this.selectedItems.find((x) => x.id === id);
    if (!exist) return false;
    return exist[type];
  }

  selectItem(event: MatCheckboxChange, item, type: 'pre' | 'post' | 'desc') {
    const exist = this.selectedItems.find((x) => x.id === item._id);
    if (!exist) {
      this.selectedItems.push({
        id: item._id,
        name: item.name,
        pre: type === 'pre',
        post: type === 'post',
        desc: type === 'desc',
      });
    } else {
      if (type === 'pre') exist.pre = event.checked;
      if (type === 'post') exist.post = event.checked;
      if (type === 'desc') exist.desc = event.checked;
    }

    let isAllSelected = true;
    for (const stop of this.itinerary.attractions) {
      const exist = this.selectedItems.find((x) => x.id === stop.item._id);
      if (!exist.pre || !exist.desc || !exist.post) {
        isAllSelected = false;
      }
    }
    this.selectAll = isAllSelected;
  }

  selectAllChange(event: MatCheckboxChange) {
    this.selectedItems = [];
    if (this.selectAll) {
      for (const stop of this.itinerary.attractions) {
        this.selectedItems.push({
          id: stop.item._id,
          name: stop.item.name,
          pre: true,
          post: true,
          desc: true,
        });
      }
    }
  }

  generate(event: ButtonTriggerEvent, trigger: MatMenuTrigger) {
    console.log(this.selectedItems);
    const query = this.itinerary.attractions
      .map((x) => x.item.name + `, ${this._visitorService.getCityName(x.item)}`)
      .join('; ');

    this._visitorService
      .sendAIQuery(
        this.itinerary.hubName,
        'generateItineraryDescriptions',
        'chatgpt',
        `Now the attractions I want to visit are: ${query}`,
        []
      )
      .pipe(finalize(event.complete))
      .subscribe((data) => {
        if (data.success) {
          const json = JSON.parse(data.data);
          console.log(json);
          this.itinerary.attractions.forEach((attraction) => {
            const generatedContent = json.attractions.find((x) =>
              x.name.includes(attraction.item.name)
            );
            if (generatedContent) {
              const selection = this.selectedItems.find(
                (x) => x.name === attraction.item.name
              );
              attraction.preDescription =
                this.selectAll || selection?.pre
                  ? generatedContent.preDescription
                  : attraction.preDescription;
              attraction.item.description =
                this.selectAll || selection?.desc
                  ? generatedContent.attractionDescription
                  : attraction.item.description;
              attraction.postDescription =
                this.selectAll || selection?.post
                  ? generatedContent.postDescription
                  : attraction.postDescription;
            }
          });

          this.generated.emit({
            itinerary: this.itinerary,
            selectedItems: this.selectedItems,
          });
          trigger?.closeMenu();
          this.parentTrigger?.closeMenu();
        }
      });
  }
}
